import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import NumberField from '@vimcar/shared-components/components/IForm/components/NumberField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import DateTimeRow from '../DateTimeRow'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomOdometerInput')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomDatedOdometerInput = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {/* @ts-expect-error@2322 */}
      <IForm
        className={styles.form}
        onChange={viewModel.handleFormChange}
        onValid={viewModel.handleFormValid}
      >
        <NumberField label={tp('odometer')} property='odometer' required />
        <DateTimeRow
          dateFieldProps={{
            maxDate: viewModel.today,
            label: tp('date'),
            name: 'date',
          }}
          // @ts-expect-error@2339
          error={viewModel.error}
          // @ts-expect-error@2339
          onChange={viewModel.handleDateChange}
          onNowClick={viewModel.handleNowClick}
          timeFieldProps={{
            label: tp('time'),
            name: 'time',
          }}
          // @ts-expect-error@2322
          value={viewModel.odometerTimestamp}
        />
      </IForm>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomDatedOdometerInput)
component.displayName = 'CustomDatedOdometerInput'
export default component
